import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  async getWeekByStartDateAndEndDate(params) {
    const response = await axios.get('uni/year-week/getWeekByStartDateAndEndDate', { params })
    const { data } = response
    if (data.code === ApiCode.SUCCESS) {
      return data.data
    }
    return null
  },

  async getSchedules(params) {
    try {
      const response = await axios.get('uni/schedules/getSchedulesV3', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records } = data.data
        return records
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getTurns() {
    try {
      const response = await axios.get('uni/turns/get_all_turn_v2')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data ? data.data.records : []
      }
    } catch (e) {
      handleCatch(e)
    }
  },
}
